import '@hey-car/intl-seo-hub.page-builder/dist/index.css';
import {
  GuidesHubPage as GuidesHubPageContent,
  getServerSideProps as getServerSidePropsGuidesHubPage,
} from 'app/containers/GuidesHubPage/GuidesHubPage';
import { PageId } from 'app/shared/components/PageWrapper/providers/PageProvider/hooks/usePageId/usePageId';
import { IBlogHubPage } from 'app/containers/BlogHubPage/BlogHubPage';

interface IGuidesHubPageProps extends IBlogHubPage {}

const GuidesHubPage = (props: IGuidesHubPageProps) => {
  return <GuidesHubPageContent {...props} pageId={PageId.GUIDES_HUB_PAGE} />;
};

export async function getServerSideProps(props) {
  return getServerSidePropsGuidesHubPage(props);
}

export default GuidesHubPage;
